import { Matchdata } from '@/types/match';

import Maps from '../../Maps';
import Scoreboard from '../../Scoreboard';

type Props = {
  matchId: string;
  match: Matchdata;
};

const Overview = (props: Props) => {
  return (
    <div className="flex flex-col gap-y-8">
      <Maps match={props.match} />
      <Scoreboard matchId={props.matchId} match={props.match} />
    </div>
  );
};

export default Overview;
